export const dossierColumns = {
    dossierNumber: true,
    lastName: true,
    maidenName: true,
    firstName: true,
    caseType: true,
    urgency: true,
    country: true,
    location: true,
    diagnose: true,
    birthDate: true,
    createdBy: true,
    creationDate: true,
    status: true,
    helpPlanCount: true,
    clientName: false,
    productName: false,
    alarmCenter: false,
    phoneNumber: false,
    helpPlanNames: false,
    supplierName: false,
    relationNumber: false,
    supplierType: false,
    lastModificationDate: false,
    calamity: false,
    incidentDate: false,
    postalCode: false,
    sspCount: false
}